module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Landing-page-w540.a6e89969.webp";